import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { datePipe, delayedFunctionCall } from '@piqet-angular/data';
import { reportTitals } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';

@Component({
  selector: 'piqet-angular-compact-detail-report',
  templateUrl: './compact-detail-report.component.html',
  styleUrls: ['./compact-detail-report.component.scss'],
})
export class CompactDetailReportComponent {
  profilePic = './assets/images/defaultProfile.jpg';
  piqetLogo = './assets/images/Piqet_NewLogo.svg';
  organizationImage = './assets/images/GlobalWarming.png';

  @Input() reportData: any;
  reportResource = reportTitals;
  mainProjectName!: string;
  remainingProjectName!: string;
  figureId = 2;
  lblSummaryResultFigureId: any;
  lblResultScenarioFigureId: any;
  figureIndexList: any = [];
  tableIndexList: any = [];
  isTocVisible = false;
  tocSections: any = [];
  isHideSensitivityAnalysis: boolean = false;
  constructor(private cd: ChangeDetectorRef) {}
  ngOnInit() {}

  updateTableId() {
    let elements = document.querySelectorAll('.uniqTableSeq');
    let count = 1;
    for (let i = 0; i < elements.length; i++) {
      elements[i].id = i + 'tableIndex';
      let innerHTML = elements[i].innerHTML;
      let updatedHTML = innerHTML.replace(/#1/g, count.toString());
      elements[i].innerHTML = updatedHTML;
      this.tableIndexList.push(elements[i].innerHTML);
      count++;
    }

    let elementsFigure = document.querySelectorAll('.uniqFigureSeq');
    let chartDesign = document.querySelectorAll('.chartDesign');
    let countFigure = 1;
    for (let i = 0; i < elementsFigure.length; i++) {
      let innerHTML = elementsFigure[i].innerHTML;
      let updatedHTML = innerHTML.replace(/#1/g, countFigure.toString());
      elementsFigure[i].innerHTML = updatedHTML;
      if (!innerHTML.includes('is shown')) {
        chartDesign[i]['id'] = countFigure - 1 + 'figureIndex';
        this.figureIndexList.push(elementsFigure[i].innerHTML);
        countFigure++;
      }
    }
  }

  ngAfterViewInit() {
    this.updateTableId();
  }
  ngOnChanges(changes: SimpleChanges) {
    this.reportData = changes['reportData'].currentValue;
    this.isHideSensitivityAnalysis = this.reportData?.isSensitivityAnalysisRights;
    this.getRemainingText();
    this.tocSections = this.getFilteredTocSections();
    this.cd.detectChanges();
  }
  toggleToc(eve: any) {
    this.isTocVisible = !this.isTocVisible;
  }
  getFilteredTocSections() {
    const sections = [
      { id: 'projectDetail', title: 'Project details' },
      {
        id: 'scenarioComparison',
        title: 'Scenario comparison',
        children: [
          { id: 'summaryResultNo', title: 'Summary of results - numbers' },
          { id: 'equivalencyUnits', title: 'Equivalency unit' },
        ],
      },
      { id: 'graphicalSummary', title: 'Graphical summary of results' },
      { id: 'scenarioDetails', title: 'Scenario details' },
      { id: 'resultsScenario', title: 'Results for scenario' },
      {
        id: 'sensitivityAnalysis',
        title: 'Sensitivity analysis',
        condition: () => this.isHideSensitivityAnalysis, // Add this condition
      },
      {
        id: 'categoryDefination',
        title: 'Categories definition',
        condition: () => this.reportData?.additionalItems.toLowerCase().includes('5'),
      },
      {
        id: 'dataSourceAtt',
        title: 'Data source and attributes',
        condition: () => this.reportData?.additionalItems.toLowerCase().includes('3'),
      },
    ];

    return sections
      .map((section: any) => {
        if (section.children) {
          section.children = section.children.filter(
            (sub: any) => !sub.condition || sub.condition()
          );
        }
        return !section.condition ||
          section.condition() ||
          (section.children && section.children.length > 0)
          ? section
          : null;
      })
      .filter(section => section !== null);
  }

  getRemainingText(): string {
    const parts = this.reportData.projectName.split(' - ');
    this.mainProjectName = parts[0];
    if (parts.length > 1) {
      this.remainingProjectName = parts.slice(1).join(' - ');
    }
    return '';
  }
  getFormateDate(date: any) {
    return datePipe(date);
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
}
